import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 全局引入element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 全局样式
import './styles/index.scss'
// 请求
import request from './utils/request'
// socket
import socket from './utils/socket'
// 上传
import UploadFile from "./components/UploadFile";
// EChats
import * as echarts from 'echarts'
// 省市选择
import AreaSelect from "./components/AreaSelect";
// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

Vue.prototype.$request = request
Vue.prototype.$socket = socket
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)

Vue.component('upload-file', UploadFile)
Vue.component('area-select', AreaSelect)

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
